import { Component, OnInit } from '@angular/core';
import { MapserviceService } from '../services/map-services.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  fullName = "";

  constructor(private mapService: MapserviceService) { }

  ngOnInit(): void {
    this.mapService.userName.subscribe((result) => {
      this.fullName = result;
    });
  }

}
